import { render } from "./addContact.vue?vue&type=template&id=2886a88b&scoped=true"
import script from "./addContact.vue?vue&type=script&lang=js"
export * from "./addContact.vue?vue&type=script&lang=js"

import "./addContact.vue?vue&type=style&index=0&id=2886a88b&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2886a88b"],['__file',"src/views/brandProduct/components/addContact.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2886a88b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2886a88b', __exports__)) {
    console.log('reload')
    api.reload('2886a88b', __exports__)
  }
  
  module.hot.accept("./addContact.vue?vue&type=template&id=2886a88b&scoped=true", () => {
    console.log('re-render')
    api.rerender('2886a88b', render)
  })

}


export default __exports__